module.exports = __webpack_public_path__ + "img/last-price.86573add.jpg";